//Global Variables for Lenses
var selectedVersion;
var sameOnBothEyes = true;
var resetVersions = false;
var initialVersionHasValue = false;
var duplicatedVersionHasValue = false;
var initialState = {}, duplicatedState = {};

Vendd.Scripts.load(function () {

    var $wrapper = $('.x-product-details'),
        wrapper;
    var model = null,
        firstLoad = true;

    if ($wrapper.length < 1)
        return;

    if (!$wrapper.hasClass('details-for-lenses'))
        return;

    wrapper = $wrapper.get(0);

    var $versions = $('.x-product-details-versions .x-versions', $wrapper);
    var $duplicatedVersions = $('.x-product-details-versions .x-duplicated-versions', $wrapper);

    var $ajaxButtons = $('.x-product-details-ajax-buttons', $wrapper);
 
    /* enable add to wishlist, when the version's selectors are selected */
    var $versionSelector = $('.x-product-details-version-selector[data-type="dropdown"]', $wrapper);
    var allVersionsSelected = true;

    $.each($versionSelector, function (i, control) {
        var $control = $(control);

        if ($('.js-selector', $control).val() == '0') {
            allVersionsSelected = false;
            return false;
        }
    });

    if (allVersionsSelected) {
        $('.availability-container', $wrapper).addClass('visible');
        $('.js-add-to-wishlist', $wrapper).removeClass('disabled');
    }

    var bundleItems = [];
    var recipeItems = [];
    var comboItems = [];
    var minQuantity = ($wrapper.data('min-quantity') ? stringToNumber($wrapper.data('min-quantity')) : null) || 0;
    var maxQuantity = ($wrapper.data('max-quantity') ? stringToNumber($wrapper.data('max-quantity')) : null) || 0;
    var quanta = ($wrapper.data('quanta') ? stringToNumber($wrapper.data('quanta')) : null) || 0;
    var qty = Vendd.Helpers.isInteger(parseFloat(quanta)) ? parseInt(minQuantity).toFixed(0) || 1 : parseFloat(minQuantity).toFixed(2) || 1;

    Vendd.Product.Controller.initState({
        serviceConfiguration: $('.configuration', $wrapper).text(),
        parentId: $wrapper.data('parent-id'),
        selectedId: $wrapper.data('selected-id'),
        selectedColorId: $wrapper.data('selected-color-id'),
        path: $wrapper.data('path'),
        languageId: $wrapper.data('language-id'),
        qty: qty > 0 ? qty : 1,
        minQuantity: Vendd.Helpers.isInteger(parseFloat(quanta)) ? parseInt(minQuantity) : parseFloat(minQuantity),
        maxQuantity: Vendd.Helpers.isInteger(parseFloat(quanta)) ? parseInt(maxQuantity) : parseFloat(maxQuantity),
        quanta: Vendd.Helpers.isInteger(parseFloat(quanta)) ? parseInt(quanta) : parseFloat(quanta),
        bundleItems: bundleItems,
        recipeItems: recipeItems,
        comboItems: comboItems
    });

    $('.configuration', $wrapper).remove();

    wrapper.bind = function () {

        if (firstLoad) {
            Vendd.MessageBus.publish(wrapper, new Vendd.Product.Messages.BindControl($wrapper));
        } else {
            //BIND VERSIONS NOT ALL WRAPPER
            wrapper.bindVersions();
        }

        formatPrices($wrapper);
        allowOnlyNumbersInput($wrapper);

        /* Already in wishlist start | First Load */
        if (firstLoad) {
            var wishlistModel = JSON.parse(localStorage.getItem("CurrentWishlistModel"));
            var isInWishlist = false;
            if (wishlistModel) {
                _.each(wishlistModel.Items, function (item) {
                    if (item.VariantId == $wrapper.data('selected-id')) {
                        isInWishlist = true;
                        $('.x-product-details-ajax-buttons .wishlist-button', $wrapper).addClass('already-in-wishlist');
                        return;
                    }
                });
            }
        }
        /* Already in wishlist end | First Load */
    };

    wrapper.bindVersions = function () {
        if (resetVersions) {
            resetVersions = false;

            if (initialVersionHasValue) {
                initialVersionHasValue = false;
                Vendd.MessageBus.publish(wrapper, new Vendd.Product.Messages.BindControl($versions));
            }
            if (duplicatedVersionHasValue) {
                duplicatedVersionHasValue = false;
                Vendd.MessageBus.publish(wrapper, new Vendd.Product.Messages.BindControl($duplicatedVersions));
            }
        } else {
            if (selectedVersion === "initial") {
                Vendd.MessageBus.publish(wrapper, new Vendd.Product.Messages.BindControl($versions));
            }
            if (selectedVersion === "duplicated") {
                Vendd.MessageBus.publish(wrapper, new Vendd.Product.Messages.BindControl($duplicatedVersions));
            }
        }       
    };

    wrapper.update = function () {
        firstLoad = false;

        /* Already in wishlist start */
        var wishlistModel = JSON.parse(localStorage.getItem("CurrentWishlistModel"));
        var isInWishlist = false;

        if (wishlistModel) {
            _.each(wishlistModel.Items, function (item) {
                if (item.VariantId == model.SelectedProductId) {
                    isInWishlist = true;
                    model.AlreadyInWishlist = true;
                    return;
                }
            });
        }
        /* Already in wishlist end */

        if (typeof canonicalBreadcrumb !== 'undefined') {
            model = $.extend({}, canonicalBreadcrumb, model);
        }

        var state = Vendd.Product.Controller.getState();
        state.selectedColorId = model.SelectedProductColorId;

        //UPDATE VERSIONS
        wrapper.updateVersions(state);

        // enable "add to wishlist"
        if (model.Dimensions.length >= 2) {
            $('.js-add-to-wishlist', '.x-product-details-ajax-buttons').removeClass('disabled');
        }

        wrapper.bind();
    };

    wrapper.updateVersions = function (state) {
        var versionsHtml, buttonsHtml;

        if (resetVersions) model.DefaultSkuLoaded = true;

        // Parse html for versions
        versionsHtml = Vendd.Handlebars.parse("pdVersions", model);

        if (resetVersions) {
            if (initialVersionHasValue) {
                //append new html for initial version
                $versions.html(versionsHtml);
                //manipulate wrapper
                $wrapper.attr('data-selected-id', $wrapper.data('default-id'));
            } 
            if (duplicatedVersionHasValue) {
                //append new html for duplicated version
                $duplicatedVersions.html(versionsHtml);
                //manipulate wrapper
                $wrapper.attr('data-selected-second-id', $wrapper.data('default-id'));
            } 
        } else {
            if (selectedVersion === "initial") {
                //save state for initial version
                initialState = JSON.parse(JSON.stringify(state));
                //append new html for initial version
                $versions.html(versionsHtml);
                //manipulate wrapper
                $wrapper.attr('data-selected-id', model.SelectedProductId);               
                $('.availability-container', $versions).addClass('visible');
            } else if (selectedVersion === "duplicated") {
                //save state for duplicated version
                duplicatedState = JSON.parse(JSON.stringify(state));
                //append new html for duplicated version
                $duplicatedVersions.html(versionsHtml);
                //manipulate wrapper
                $wrapper.attr('data-selected-second-id', model.SelectedProductId);                
                $('.availability-container', $duplicatedVersions).addClass('visible');
            }
        }

        //Enable Add to Wishlist
        if (!sameOnBothEyes && initialVersionHasValue && duplicatedVersionHasValue) {
            model.AlreadyInWishlist = false;
        }
        // Parse html for ajax buttons
        buttonsHtml = Vendd.Handlebars.parse("pdAjaxButtons", model);

        //append html for ajax buttons
        if (sameOnBothEyes) {
            $ajaxButtons.html(buttonsHtml);
        } else {
            if (initialVersionHasValue && duplicatedVersionHasValue) {
                $ajaxButtons.html(buttonsHtml);
            }
        }
    };

    wrapper.resetAjaxButtons = function () {
        //Disable Add To Cart
        model.Buttons.HasAddToCart = false;
        //Disable Wishlist
        model.Buttons.HasAddToWishlist = false;
        // Parse html for ajax buttons
        var buttonsHtml = Vendd.Handlebars.parse("pdAjaxButtons", model);
        $ajaxButtons.html(buttonsHtml);
    };

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.Changed, wrapper, function (envelope) {
        model = envelope.message.data.model;
        wrapper.update();
    });

    //show in cart message
    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, 'x-product-details', function (envelope) { 
        var data = envelope.message.data.Cart.Items;
        var id = $wrapper.data('parent-id');
        var $inCartMessage = $wrapper.find('.js-in-cart');

        $inCartMessage.hide();

        for (var j = 0; j < data.length; j++) {
            if (id === data[j].ProductId) {
                $inCartMessage.show();
            }
        }
    });

    //lazy-load-prices
    var lazyLoadPrices = $('.lazy-load-prices', $wrapper).text().toLowerCase().trim() === "true";
    if (lazyLoadPrices) {        
        Vendd.MessageBus.subscribe(Vendd.User.Messages.GetUserViewModelSuccess, wrapper, function (envelope) {
            //if lazy load enabled run this after user profile has been loaded since we need 
            var skuId = parseInt($('.x-control.x-product-details-lenses[data-selected-id]').attr('data-selected-id'));

            deleteSpinnerInstances();

            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Product.Messages.SetSelected({ id: skuId, visitorInitiated : false }));
        });
    }

    wrapper.bind();

    var funcCookiesEnabled = true;
    if (window.ConsentsManager) {
        funcCookiesEnabled = window.ConsentsManager.cookiesStatus.functionalityCookies;
    }

    if (LhApp.Context.LastViewedProducts != undefined && funcCookiesEnabled) {
        if (LhApp.Context.LastViewedProducts.LastViewedProductsIsActive) {
            var expirationDays = LhApp.Context.LastViewedProducts.LastViewedProductsExpirationDays;
            var productNumber = LhApp.Context.LastViewedProducts.LastViewedProductsNumber;
            var productId = LhApp.Context.Item.Id;

            var products = Cookies.get("LastViewedProducts") || "";
            var productsArray = _.reject(products.split(","), function (el) { return el == productId || el == ""; });
            productsArray.unshift(productId);
            var cookieValue = (_.first(productsArray, productNumber)).join(",");
            var expireDate = new Date();
            expireDate.setTime(expireDate.getTime() + expirationDays * 24 * 60 * 60 * 1000);
            Cookies.set("LastViewedProducts", cookieValue, { secure: LhApp.Context.Request.IsSecure, expires: expireDate, samesite: 'Lax' });
        }
    }

    //checkbox for power on both eyes
    $('.js-chk-both-eyes', $wrapper).change(function () {
        if ($(this).is(':checked')) {
            sameOnBothEyes = true;
            $('.versions-container', $wrapper).addClass('same-on-both-eyes');
        } else {
            sameOnBothEyes = false;
            $('.versions-container', $wrapper).removeClass('same-on-both-eyes');

            if (initialVersionHasValue && !duplicatedVersionHasValue) {
                wrapper.resetAjaxButtons();
            }
        }

        if (initialVersionHasValue || duplicatedVersionHasValue) {
            resetVersions = true;
            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Product.Messages.SetSelected({ id: $wrapper.data('default-id'), visitorInitiated: true }));
        }
       
    });

    //list of related colors
    $('.related-colors-container .js-color-list', $wrapper).click(function () {
        var $this = $(this);

        if ($this.siblings('.color-list').hasClass('hidden')) {
            $this.siblings('.color-list').removeClass('hidden');
            $this.removeClass('icon-arrow-down').addClass('icon-arrow-up');
        } else {
            $this.siblings('.color-list').addClass('hidden');
            $this.removeClass('icon-arrow-up').addClass('icon-arrow-down');
        }
    });

    $(document).click(function (e) {
        if (!$(e.target).hasClass('js-color-list')) {
            $('.related-colors-container .color-list').addClass('hidden');
            $('.related-colors-container .js-color-list').removeClass('icon-arrow-up').addClass('icon-arrow-down');
        }
    });

});
